/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Game } from './Game';
export type InMemoryAlertDto = {
    /**
     * Unique identifier for the alert
     */
    id: string;
    /**
     * Alert title
     */
    title: string;
    /**
     * Alert description
     */
    description: string;
    /**
     * Severity level of the alert
     */
    severity: InMemoryAlertDto.severity;
    /**
     * Alert category
     */
    category: InMemoryAlertDto.category;
    /**
     * Whether the alert has been acknowledged
     */
    acknowledged: boolean;
    /**
     * Additional metadata for the alert
     */
    metadata: Record<string, any>;
    /**
     * Game type
     */
    game: Game;
    /**
     * League name
     */
    league: string;
    /**
     * Owner ID
     */
    ownerId: string;
    /**
     * Character ID (if applicable)
     */
    characterId: Record<string, any> | null;
    /**
     * Name of the character
     */
    characterName: Record<string, any>;
    /**
     * Game account ID (if applicable)
     */
    gameAccountId: Record<string, any> | null;
    /**
     * Game account name (if applicable)
     */
    gameAccountName: Record<string, any> | null;
    /**
     * Item ID (if applicable)
     */
    itemId: Record<string, any> | null;
    /**
     * Item name (if applicable)
     */
    itemName: Record<string, any> | null;
    /**
     * Item timestamp (if applicable)
     */
    itemTimestamp: Record<string, any> | null;
    /**
     * Alert creation timestamp
     */
    createdAt: string;
    /**
     * Alert last update timestamp
     */
    updatedAt: string;
};
export namespace InMemoryAlertDto {
    /**
     * Severity level of the alert
     */
    export enum severity {
        LOW = 'low',
        MEDIUM = 'medium',
        HIGH = 'high',
        CRITICAL = 'critical',
    }
    /**
     * Alert category
     */
    export enum category {
        CHARACTER = 'character',
        ITEM = 'item',
        SYSTEM = 'system',
        MARKET = 'market',
    }
}

